import type { MyMenuOptions } from "./myMenuOptions";

export const navSubUpperOptions: NavSubUpperOption[] = [
  {
    label: "Nachrichten",
    href: "/m-nachrichten.html",
    enablingAttribute: "none",
  },
  {
    label: "Anzeigen",
    href: "/m-meine-anzeigen.html",
    enablingAttribute: "none",
  },
  {
    label: "Unternehmensseite",
    href: "/m-pro/info.html",
    enablingAttribute: "showProBizMenu",
  },
  {
    label: "Statistiken",
    href: "/m-statistiken.html",
    enablingAttribute: "showStatisticsMenu",
  },
  {
    label: "Buchungen",
    href: "/m-buchungs-uebersicht.html",
    enablingAttribute: "showBookingOverviewMenu",
  },
  {
    label: "Rechnungen",
    href: "/m-rechnungen.html",
    enablingAttribute: "showInvoicesMenu",
  },
  {
    label: "Einstellungen",
    href: "/m-einstellungen.html",
    enablingAttribute: "none",
  },
  {
    label: "Kundensupport",
    href: "/m-kundensupport.html",
    enablingAttribute: "showCustomerSupportMenu",
  },
  {
    label: "Follower-Ansprache",
    href: "/follower-ansprache-demo.html",
    enablingAttribute: "showFollowerTargetingDemoMenu",
  },
  {
    label: "PRO upgraden",
    href: "/m-pro-upgrade.html",
    enablingAttribute: "showUpsellingMenu",
  },
  {
    label: "Follower-Ansprache",
    href: "/follower-ansprache.html",
    enablingAttribute: "showFollowerTargetingMenu",
  },
];

type NavSubUpperOption = {
  label: string;
  href: string;
  enablingAttribute: keyof MyMenuOptions | "none";
};

export function getNavSubUpperOptions(
  myMenuOptions: MyMenuOptions,
): NavSubUpperOption[] {
  const enabledOptions: NavSubUpperOption[] = [];
  navSubUpperOptions.forEach((option) => {
    if (option.enablingAttribute === "none") {
      enabledOptions.push(option);
    } else if (myMenuOptions[option.enablingAttribute as keyof MyMenuOptions]) {
      enabledOptions.push(option);
    }
  });
  return enabledOptions;
}
